import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";
import moment from "moment";
import {userLevelMap} from "./UsersTable";
import {nanoid} from "@reduxjs/toolkit";
import {GREEN_COLOR, RED_COLOR, SELECT_BACK_COLOR} from "../../components/CONSTANTS";


const inmsgChannelMap = {
    backgroundColor: '#18111c',
    values: {
        "VIBER": {
            rawValue: "VIBER",
            icon: 'viber',
            lang: {
                ua: "VIBER",
                en: "START"
            },
            color: '#bc30ee'
        },
        "WEB": {
            rawValue: "WEB",
            icon: 'web',
            lang: {
                ua: "WEB",
                en: "SMART"
            },
            color: '#238dfe'
        }
    }
} as FieldMap;

const inmsgMsgTypeMap = {
    groups: [{
        label: {
            ua: "Коректні",
            en: "START"
        },
        values: ["4"]
    }, {
        label: {
            ua: "Некоректні",
            en: "START"
        },
        values: ["3", "2", "1"]
    }],
    //backgroundColor: '#18111c',
    backgroundColor: SELECT_BACK_COLOR,
    values: {
        "4": {
            rawValue: "4",
            lang: {
                ua: "Коректний",
                en: "START"
            },
            color: GREEN_COLOR
        },
        "3": {
            rawValue: "3",
            lang: {
                ua: "Дублікат",
                en: "SMART"
            },
            color: RED_COLOR
        },
        "2": {
            rawValue: "2",
            lang: {
                ua: "Немає в базі",
                en: "SMART"
            },
            color: RED_COLOR
        },
        "1": {
            rawValue: "1",
            lang: {
                ua: "Некоректний",
                en: "SMART"
            },
            color: RED_COLOR
        }
    }
} as FieldMap;

const inmsgStickerStatusMap = {
    groups: [{
        label: {
            ua: "Новий",
            en: "START"
        },
        values: ["new"]
    }, {
        label: {
            ua: "Прийнято",
            en: "START"
        },
        values: ["accepted"]
    }, {
        label: {
            ua: "Відхилено",
            en: "START"
        },
        values: ["rejected:1", "rejected:2", "rejected:3"]
    }],
    backgroundColor: '#18111c',
    values: {
        "new": {
            rawValue: "new",
            lang: {
                ua: "Новий",
                en: "START"
            },
            color: '#ffed35'
        },
        "accepted": {
            rawValue: "accepted",
            lang: {
                ua: "Прийнято",
                en: "START"
            },
            color: '#32d922'
        },
        "rejected:1": {
            rawValue: "rejected:1",
            lang: {
                ua: "Відхилено (погана якість)",
                en: "SMART"
            },
            color: '#d5060d'
        }, "rejected:2": {
            rawValue: "rejected:2",
            lang: {
                ua: "Відхилено (не відповідає умовам)",
                en: "SMART"
            },
            color: '#d5060d'
        },
        "rejected:3": {
            rawValue: "rejected:3",
            lang: {
                ua: "Відхилено (дублікат фото)",
                en: "SMART"
            },
            color: '#d5060d'
        }
    }
} as FieldMap;

let fieldOperations: FieldOperations = {
    dt: [...OpsCategories.range],
    msgtype: [...OpsCategories.in],
    sticker_status: [...OpsCategories.in],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    message: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    codes: [...OpsCategories.range],
    balls: [...OpsCategories.range],
    balls_for_first: [...OpsCategories.range],
    vac_level: [...OpsCategories.null],
    name: [...OpsCategories.like],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};
export const ImnsgTable: TableI = {
    backend: "/287/",
    title: {
        ua: "Реєстрації",
        en: "Замовлення",
    },
    pk: 'id',
    defaultOrderedBy: "id",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
        "dt": {ua: "Створено", ru: "Дата"},
        "codes": {ua: "Реєстрацій", ru: "Регистраций"},
        "balls": {ua: "Балів за реєстрацію", ru: "Балов за регистрацию"},
        "balls_for_first": {ua: "Додаткове нарахування балів по коду", ru: "Додаткове нарахування балів по коду"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'inmsg287DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№", ru: "№"}, type: "number",
            applyTransform: true
        },
        {
            key: "balls",
            title: {ua: "Балів за реєстрацію", ru: "Балов за регистрацию"},
            type: 'number',
            detailed: true,
            inline: false,
            headAlign: "left",
            editable: true,
            inlineEditable: true,
            updateSingleFieldPath: 'updateInmsgBalls.php'
        },
        {
            key: "balls_for_first",
            title: {ua: "Додаткове нарахування балів по коду", ru: "Додаткове нарахування балів по коду"},
            shortHead: {ua: "Дод. нарахування"},
            type: 'number',
            detailed: true,
            inline: false,
            headAlign: "left",
            editable: true,
            inlineEditable: true,
            updateSingleFieldPath: 'updateInmsgBalls.php'
        },
        {
            key: "vac_level",
            title: {ua: "Нараховані бали по рівню", ru: "Нараховані бали по рівню"},
            shortHead: {ua: "По рівню"},
            type: 'string',
            detailed: true,
            inline: false,
            headAlign: "left",
        },

        {
            key: "dt",
            title: {ua: "Дата", ru: "Дата"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: false,
            inline: true,
            headAlign: "left",
        },
        {
            key: "msisdn", type: 'tel',
            applyTransform: true,
            detailed: false, inline: true,
            headAlign: "left",
            title: {ua: "Телефон", ru: "Телефон"}
        },
        {
            key: "message",
            getColumnValue: "act287getInmsgCodeColumnValue",
            title: {ua: "Код", ru: "Код"},
            type: "string",
            applyTransform: true,
            detailed: false,
            inline: true,
            headAlign: "left",
        },
        {
            key: "sn",
            type: 'map',
            title: {ua: "Канал"},
            detailed: false,
            inline: true,
            applyTransform: true,
            map: inmsgChannelMap
        },
        {
            key: "msgtype",
            title: {ua: "Статус", ru: "Статус"},
            type: "map",
            map: inmsgMsgTypeMap,
            inline: true,
            detailed: false,
            applyTransform: true,
            headAlign: "left",
        },
        {key: "sticker",
            title: {ua: "Стікер"},
            type: 'image',
            detailed: true,
            applyTransform: true,
            imageMaxHeight: 200,
            imageMaxWidth: 500
        },
        {key: "sticker_status",
            title: {ua: "Статус стікера"},
            type: 'map',
            detailed: true,
            inline: true,
            inlineEditable: true,
            editable: true,
            applyTransform: true,
            map: inmsgStickerStatusMap,
            headAlign: "left"
        },
        {key: "name", type: 'string', inline: true, headAlign: "left", title: {ua: "Користувач", ru: "Пользователь"}},

        {key: "product", title: {ua: "Модель", ru: "Модель"}, type: 'string', detailed: true, inline: true},
        {
            key: "balls_from_inviter",
            title: {ua: "Приведи Друга (1 якщо так)", ru: "Приведи Друга (1 если Да)"},
            type: 'string',
            detailed: true,
            inline: false,
            editable: true,
            updateSingleFieldPath: 'updateInmsgBalls.php'
        },
        {
            key: "codes",
            title: {ua: "Реєстрацій"},
            type: "number",
            inline: true,
            headAlign: "left",
        },
        {key: "comment", title: {ua: "Коментар", ru: "Комментарий"}, type: 'string',},

        {
            key: "user_level",
            title: {ua: "Рівень користувача", ru: "Уровень пользователя"},
            detailed: true,
            inline: true,
            headAlign: "left",
            applyTransform: true,
            type: "map",
            map: userLevelMap,
        },
        {
            key: "is_from_ur_osoba",
            title: {ua: "Запрошений юр. особою"},
            type: "boolean",
            applyTransform: true,
            inline: false,
            detailed: true,
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {key: "ip", title: {ua: "IP", ru: "IP"}, type: 'string', detailed: true, inline: false},
        {
            key: "ref_user",
            title: {ua: "Користувач"},
            detailed: true,
            applyTransform: true,
            searchRef: [
                {
                    table: "inmsg",
                    condition: [{
                        mainField: "msisdn",
                        op: SqlOperation.LIKE
                    }]
                }
            ],
            type: 'ref',
            ref: {
                entity: "user",
                keys: ['id', 'name', 'email', 'codes', 'free', 'used', 'confirm', 'auth_adjuster_dt'],
                fetchMode: "lazy",
                order: {
                    field: "id",
                    way: "DESC"
                },
                limit: 1,
                single: true,
                layout: "vertical-list",
                condition: [{
                    mainField: "msisdn",
                    op: SqlOperation.EQUAL
                }]
            }
        },
    ]
}

export function inmsg287DefFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.GREATER_THAN_OR_EQUAL,
            locked: true,
            value: moment().subtract(7, 'days').startOf('day').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.LESS_THAN_OR_EQUAL,
            locked: true,
            value: moment().endOf('day').locale('en').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'msisdn',
            type: 'tel',
            filterOp: SqlOperation.LIKE,
            locked: true,
            value: ''
        },
        {
            nanoid: nanoid(),
            field: 'msgtype',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: []
        },
        {
            nanoid: nanoid(),
            field: 'sticker_status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: []
        },
        {
            nanoid: nanoid(),
            field: 'message',
            type: 'string',
            filterOp: SqlOperation.LIKE,
            locked: true,
            value: ''
        },
    ]
}
